import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../../../environments/environment';
import { IProject } from '../models/iproject';

@Injectable()
export class ProjectService {

  private _apiEndPoint = environment.trotsAPI.url + environment.trotsAPI.endPoints.projects;
  
  constructor(private _httpClient: HttpClient) { 
  }

  getProjects(amount: number):Observable<Array<IProject>> {
    return this._httpClient.get<Array<IProject>>(`${ this._apiEndPoint }`);
  }

  getProjectsById(id: number):Observable<IProject> {
    return this._httpClient.get<IProject>(`${ this._apiEndPoint }`);
  }

}



// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/projects/shared/services/project.service.ts